import { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DUMMY_CANDIDATES } from "@/pages/candidates/dummyCandidates";
import Back from "@/components/specific/Back";
import CandidateHeader from "@/pages/candidates/components/candidate_details/Candidate_Header";
import QuickStats from "@/pages/candidates/components/candidate_details/Quick_Stats";
import CandidateStats from "@/pages/candidates/components/candidate_details/Candidate_Stats";
import CandidateReport from "@/pages/candidates/components/candidate_details/Candidate_Report";
import CandidatesVersus from "@/pages/candidates/components/candidate_details/Candidate_Versus";
import candidateImage from "@/assets/images/candidate_1.png";

const SingleCandidate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Transform API data to match UI requirements
  const candidateData = useMemo(() => {
    // Look up the candidate from the same dummy dataset used in the list.
    if (!id) return null;
    const rawCandidate = DUMMY_CANDIDATES.find(
      (candidate) => candidate.id === id
    );

    if (!rawCandidate) return null;

    return {
      name: rawCandidate.fullName,
      position: rawCandidate.position,
      location: rawCandidate.state || "Countrywide", // Default to countrywide if state is missing
      coverImage: candidateImage,
      party: rawCandidate.party,
      organizationID: rawCandidate.organizationID,
      createdAt: rawCandidate.createdAt,
      updatedAt: rawCandidate.updatedAt,
      // Additional UI-specific dummy data
      runningMate: {
        name: "Sade Adu",
        avatar: null,
      },
      stats: {
        voters: 302000,
        competitors: 5,
        winnings: 100,
        losses: 15,
      },
      registeredVoters: 2394412,
      lastUpdated: new Date(rawCandidate.updatedAt).toLocaleString(),
      chartData: [
        { time: "09:00", value: 100000 },
        { time: "10:00", value: 150000 },
        { time: "11:00", value: 300000 },
        { time: "12:00", value: 500000 },
        { time: "13:00", value: 200000 },
        { time: "14:00", value: 600000 },
      ],
      competitors: [
        {
          id: 1,
          name: "Olusegun Obasanjo",
          party: "State Democratic Party (SDP)",
          avatar: null,
          votes: 2198801,
          percentage: 20,
        },
        // ... more competitors
      ],
    };
  }, [id]);

  if (!candidateData) return null;

  return (
    <div className="w-full text-left lg:border lg:rounded-lg lg:p-5">
      <div className="mb-4 xl:hidden">
        <Back text="Back" onClick={() => navigate("/dashboard/candidates")} />
      </div>

      <div className="justify-between p-2 rounded-lg 2xl:flex md:border">
        <div className="pr-2 mb-6 border-r 2xl:mb-0">
          <CandidateHeader
            candidate={candidateData}
            runningMate={candidateData.runningMate}
          />
        </div>

        <div className="">
          <QuickStats stats={candidateData.stats} />
        </div>
      </div>

      <div className="mt-5 md:border-b">
        <CandidateStats
          registeredVoters={candidateData.registeredVoters}
          lastUpdated={candidateData.lastUpdated}
          location={candidateData.location}
        />
      </div>

      <div className="flex-row-reverse gap-5 md:flex md:mt-5">
        <div className="flex-1">
          <div className="p-6 mb-6 rounded-lg bg-secondary">
            <div className="mb-2">
              <h3 className="mb-2 text-bold-x">
                Registered Voters:{" "}
                {candidateData.registeredVoters.toLocaleString()}
              </h3>
              <p className="mb-4 text-small text-lighterGrey">
                Updated: {candidateData.lastUpdated}
              </p>
              <p className="mb-1 text-small text-lighterGrey">
                Results from Ugele LGA, Ward 1 Polling Unit, Abia State
              </p>
            </div>

            <div className="flex gap-2 cursor-pointer text-small">
              <span className="material-icons">location_on</span>
              <span className="text-black">Open Location Map</span>
            </div>
          </div>

          <div className="p-4 mt-6 rounded-lg bg-lightDanger">
            <p className="font-bold text-regular text-danger">WARNING!</p>
            <p className="preserve-text-black text-small">
              Please note that this isn&apos;t an official record or final
              result from INEC. Veegi will not be liable for misinformation or
              fake news.
            </p>
          </div>

          <div className="p-2 mt-6 rounded-lg md:border">
            <CandidateReport data={candidateData.chartData} />
          </div>
        </div>

        <div className="flex-1 mt-6">
          <CandidatesVersus candidates={candidateData.competitors} />
        </div>
      </div>
    </div>
  );
};

export default SingleCandidate;
